export default __webpack_public_path__ + "static/1920X938_SLIDER_1-83ec4d128016e9be9cbccf99f55ef38a.jpg";